import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Modal, Divider } from "antd";
import { BrowserView, MobileView } from "react-device-detect";
import { useAsyncAxios, utilAxiosWithAppToken, utilAxiosWithAuth } from "../../utils/customAxios";
import { useAuthState } from "../../provider/AuthProvider";
import { useMediaQuery } from "react-responsive";
//import { allPlaces } from "./TravelSpot";

import * as Request from "../../commons/request";
import * as TypeDTO from "../../commons/typeDTO";
import * as TypeUtils from "../../commons/typeUtils";
import * as Common from "../../commons/common";
import * as String from "../../commons/string";
import * as Utils from "../../utils/utils";

import moment from "moment";
import ImageSlider from "../../component/ImageSlider";
import Search from "../../component/rent/Search";
import GoodsCard from "../../component/rent/GoodsCard";
import ReviewCard from "../../component/rent/ReviewCard";
import MainCarousel from "../../component/rent/MainCarousel";
import TravelSpotCard from "../../component/rent/TravelSpotCard";
import RentVideoManualCard from "../../component/rent/RentVideoManualCard";
import KakaoMap from "../../component/KakaoMap";
import CustomSheet from "../../component/CustomSheet";
import ReviewSimpleCard from "../../component/rent/ReviewSimpleCard";

import Banner2 from "../../assets/images/home/rent/banner_main2.png";
import Banner3 from "../../assets/images/home/rent/banner_main3.jpg";
import Banner4 from "../../assets/images/home/rent/banner_main4.jpg";
import Banner9 from "../../assets/images/home/rent/banner_main9.png";
import Banner2Max from "../../assets/images/home/rent/banner_main_max2.png";
import Banner3Max from "../../assets/images/home/rent/banner_main_max3.jpg";
import Banner4Max from "../../assets/images/home/rent/banner_main_max4.jpg";
import Banner9Max from "../../assets/images/home/rent/banner_main_max9.png";
import MobileBanner2 from "../../assets/images/home/rent/banner_main_mobile2.png";
import MobileBanner3 from "../../assets/images/home/rent/banner_main_mobile3.jpg";
import MobileBanner4 from "../../assets/images/home/rent/banner_main_mobile4.jpg";
import MobileBanner9 from "../../assets/images/home/rent/banner_main_mobile9.png";

import Title from "../../component/rent/Title";
import NoData from "../../component/NoData";
import IconDigitalKey from "../../assets/images/home/rent/icon_home_digitalKey.png";
import IconEVCharger from "../../assets/images/home/rent/icon_evCharger.png";
import IconRight from "../../assets/images/home/rent/icon_right.svg";
import IconNaver from "../../assets/images/home/rent/icon_navi_naver.png";
import IconKakao from "../../assets/images/home/rent/icon_navi_kakao.png";
import IconTmap from "../../assets/images/home/rent/icon_tmap.png";
import CustomLoading from "../../component/rent/CustomLoading";

import ReservationPopup from "../../component/rent/ReservationPopup";

type RentsByDate = {
    [key: string]: Array<TypeDTO.RentDto>;
};

function Home() {
    const navigate = useNavigate();
    const userDetails = useAuthState();
    const isMax = useMediaQuery({ minWidth: 1800 });

    const [loading, setLoading] = useState<boolean>(true);
    const [b2bLoading, setB2bLoading] = useState<boolean>(true);

    const [rents, setRentCars] = useState<Array<{ regionName: string; rentCars: Array<TypeDTO.RentCarDto> }>>([]);
    const [b2bRents, setB2bRentCars] = useState<Array<{ regionName: string; rentCars: Array<TypeDTO.RentCarDto> }>>([]);
    const [search, setSearch] = useState<TypeUtils.SearchType>();
    const [b2bSearch, setB2bSearch] = useState<TypeUtils.SearchType>();

    const [openReservationPopup, setOpenReservationPopup] = useState(true);

    const [disableStartDates, setDisableStartDates] = useState<Array<string>>([]); // TODO: display calendar
    const [disableB2bStartDates, setDisableB2bStartDates] = useState<Array<string>>([]); // TODO: display calendar

    const [bestReviews, setBestReviews] = useState<Array<TypeDTO.BoardArticleDto>>([]);
    const [rentVideoManuals, setRentVideoManuals] = useState<Array<TypeDTO.RentVideoManualDto>>([]);
    const [rentPeriodLimits, setRentPeriodLimits] = useState<Array<TypeDTO.RentPeriodLimitDto>>();
    const [rentPeakSeasons, setRentPeakSeasons] = useState<Array<TypeDTO.RentPeakSeasonDto>>();

    const [banners, setBanners] = useState<Array<string>>([]);
    const [mobileBanners, setMobileBanners] = useState<Array<string>>([]);
    const [travelSpot, setTravelSpot] = useState<any>(null);

    const [originPlaces, setOriginPlaces] = useState<Array<TypeDTO.RentTravelSpotDto>>([]);
    const [modifiedPlaces, setModifiedPlaces] = useState<Array<TypeDTO.RentPlaceDto>>([]);

    useEffect(() => {
        requestGetRentCars();
        requestGetB2bRentCars();

        requestGetBoardArticles("1");
        requestGetRentVideoManuals();
        requestGetRentPeriodLimits();
        requestGetRentPeakSeasons();
        requestGetTravelSpots();

        const today = moment().format(Common.FORMAT_DATE_TIME);

        const showReservationPopup = window.localStorage.getItem("showReservationPopup");

        if (showReservationPopup !== null) {
            const obj = JSON.parse(showReservationPopup);
            const expire = moment(obj.expire).format(Common.FORMAT_DATE_TIME);

            if (expire > today) {
                setOpenReservationPopup(false);
            } else {
                window.localStorage.removeItem("showReservationPopup");
                setOpenReservationPopup(true);
            }
        }
    }, []);

    useEffect(() => {
        requestGetRentCars();
    }, [search]);

    useEffect(() => {
        requestGetB2bRentCars();
    }, [b2bSearch]);

    useLayoutEffect(() => {
        setBanners(isMax ? [Banner9Max, Banner2Max, Banner4Max, Banner3Max] : [Banner9, Banner2, Banner4, Banner3]);
        setMobileBanners([MobileBanner9, MobileBanner2, MobileBanner4, MobileBanner3]);
    }, [isMax]);

    //get rentCars
    const requestAxiosGetRentCars = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_CARS_URL, {
            params: {
                rentRegionId: search?.regionId === 0 ? undefined : search?.regionId,
                startDate: search?.period && search?.period[0],
                endDate: search?.period && search?.period[1],
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetRentCars,
        error: errorGetRentCars,
        data: resultGetRentCars,
        execute: requestGetRentCars,
    } = useAsyncAxios(requestAxiosGetRentCars);

    useEffect(() => {
        setLoading(true);
    }, [loadingGetRentCars]);

    useEffect(() => {
        if (!resultGetRentCars) return;
        console.log("resultGetRentCars", resultGetRentCars);

        let rentRegionId = 0;
        let rentCarsByRegionItem: { regionName: string; rentCars: Array<TypeDTO.RentCarDto> };
        let count = 0;

        const rentCarsByRegion: Array<{ regionName: string; rentCars: Array<TypeDTO.RentCarDto> }> = [];

        resultGetRentCars.rentCars
            ?.filter((rentCar: TypeDTO.RentCarDto) => !rentCar?.b2b)
            .forEach((rentCar: TypeDTO.RentCarDto) => {
                if (rentRegionId != rentCar.rentRegion.rentRegionId) {
                    rentRegionId = rentCar.rentRegion.rentRegionId;
                    rentCarsByRegionItem = {
                        regionName: rentCar.rentRegion.rentRegionName,
                        rentCars: [],
                    };
                    rentCarsByRegion.push(rentCarsByRegionItem);
                }
                rentCarsByRegionItem.rentCars.push(rentCar);
                count++;
            });

        setRentCars(rentCarsByRegion);
        requestGetRentReservations();
        setLoading(false);
    }, [resultGetRentCars]);

    useEffect(() => {
        if (!errorGetRentCars) return;
        console.log("errorGetRentCars", errorGetRentCars);

        setLoading(false);
    }, [errorGetRentCars]);

    //b2b get rentCars
    const requestAxiosGetB2bRentCars = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_CARS_URL, {
            params: {
                rentRegionId: b2bSearch?.regionId === 0 ? undefined : b2bSearch?.regionId,
                startDate: b2bSearch?.period && b2bSearch?.period[0],
                endDate: b2bSearch?.period && b2bSearch?.period[1],
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetB2bRentCars,
        error: errorGetB2bRentCars,
        data: resultGetB2bRentCars,
        execute: requestGetB2bRentCars,
    } = useAsyncAxios(requestAxiosGetB2bRentCars);

    useEffect(() => {
        setB2bLoading(true);
    }, [loadingGetB2bRentCars]);

    useEffect(() => {
        if (!resultGetB2bRentCars) return;
        console.log("resultGetB2bRentCars", resultGetB2bRentCars);

        let rentRegionId = 0;
        let rentCarsByRegionItem: { regionName: string; rentCars: Array<TypeDTO.RentCarDto> };
        let count = 0;

        const b2bRentCarsByRegion: Array<{ regionName: string; rentCars: Array<TypeDTO.RentCarDto> }> = [];

        resultGetB2bRentCars.rentCars
            ?.filter((rentCar: TypeDTO.RentCarDto) => rentCar?.b2b)
            .forEach((rentCar: TypeDTO.RentCarDto) => {
                if (rentRegionId != rentCar.rentRegion.rentRegionId) {
                    rentRegionId = rentCar.rentRegion.rentRegionId;
                    rentCarsByRegionItem = {
                        regionName: rentCar.rentRegion.rentRegionName,
                        rentCars: [],
                    };
                    b2bRentCarsByRegion.push(rentCarsByRegionItem);
                }
                rentCarsByRegionItem.rentCars.push(rentCar);
                count++;
            });

        setB2bRentCars(b2bRentCarsByRegion);
        requestGetB2bReservations();
        setB2bLoading(false);
    }, [resultGetB2bRentCars]);

    useEffect(() => {
        if (!errorGetB2bRentCars) return;
        console.log("errorGetRentCars", errorGetB2bRentCars);

        setB2bLoading(false);
    }, [errorGetB2bRentCars]);

    //get reservations
    const requestAxiosGetRentReservations = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENTS_URL, {
            params: {
                rentRegionId: search?.regionId === 0 ? undefined : search?.regionId,
                startDate: moment().startOf("month").format("YYYY-MM-DD"),
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetRentReservations,
        error: errorGetRentReservations,
        data: resultGetRentReservations,
        execute: requestGetRentReservations,
    } = useAsyncAxios(requestAxiosGetRentReservations);

    useEffect(() => {
        if (!resultGetRentReservations) return;

        const reservationByStartDate: RentsByDate = {};

        const reservationRents: Array<TypeDTO.RentDto> = resultGetRentReservations.rents;
        const reservations = reservationRents.filter((reservation) => !reservation.rentCar.b2b);

        reservations.forEach((reservation) => {
            if (reservation.rentCar.repairing || reservation.rentCar.waiting || reservation.rentCar.unavailable) return;

            const allStartDates = getAllStartDateBetweenDate(reservation.startDate, reservation.endDate);
            allStartDates.forEach((date) => {
                if (!reservationByStartDate[date]) reservationByStartDate[date] = [];
                reservationByStartDate[date].push(reservation);
            });
        });

        const totalRentCars = rents.reduce((acc, rent) => acc + (rent.rentCars?.length ?? 0), 0);
        setDisableStartDates(Object.keys(reservationByStartDate).filter((date) => reservationByStartDate[date].length >= totalRentCars));
    }, [resultGetRentReservations]);

    useEffect(() => {
        if (!errorGetRentReservations) return;
        console.log("errorGetRentReservations", errorGetRentReservations);
    }, [errorGetRentReservations]);

    //get b2bReservation
    const requestAxiosGetB2bReservations = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENTS_URL, {
            params: {
                rentRegionId: b2bSearch?.regionId === 0 ? undefined : b2bSearch?.regionId,
                startDate: moment().startOf("month").format("YYYY-MM-DD"),
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetB2bReservations,
        error: errorGetB2bReservations,
        data: resultGetB2bReservations,
        execute: requestGetB2bReservations,
    } = useAsyncAxios(requestAxiosGetB2bReservations);

    useEffect(() => {
        if (!resultGetB2bReservations) return;

        const b2bReservationByStartDate: RentsByDate = {};

        const reservationRents: Array<TypeDTO.RentDto> = resultGetB2bReservations.rents;
        const b2bReservations = reservationRents.filter((reservation) => reservation.rentCar.b2b);

        b2bReservations.forEach((reservation) => {
            if (reservation.rentCar.repairing || reservation.rentCar.waiting || reservation.rentCar.unavailable) return;

            const allStartDates = getAllStartDateBetweenDate(reservation.startDate, reservation.endDate);
            allStartDates.forEach((date) => {
                if (!b2bReservationByStartDate[date]) b2bReservationByStartDate[date] = [];
                b2bReservationByStartDate[date].push(reservation);
            });
        });

        const totalB2bRentCars = b2bRents.reduce((acc, rent) => acc + (rent.rentCars?.length ?? 0), 0);
        setDisableB2bStartDates(Object.keys(b2bReservationByStartDate).filter((date) => b2bReservationByStartDate[date].length >= totalB2bRentCars));
    }, [resultGetB2bReservations]);

    useEffect(() => {
        if (!errorGetB2bReservations) return;
        console.log("errorGetB2bReservations", errorGetB2bReservations);
    }, [errorGetB2bReservations]);

    //get myShareCars
    const requestAxiosGetMyShareCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.SHARER_MINE_URL);
        return response.data;
    };

    const {
        loading: loadingGetMyShareCarsForDigitalKey,
        error: errorGetMyShareCarsForDigitalKey,
        data: resultGetMyShareCarsForDigitalKey,
        execute: requestGetMyShareCarsForDigitalKey,
    } = useAsyncAxios(requestAxiosGetMyShareCars, false, false, true);

    useEffect(() => {
        if (!resultGetMyShareCarsForDigitalKey) return;
        if (resultGetMyShareCarsForDigitalKey.carSharers.length === 0) {
            Modal.info({
                centered: true,
                title: "디지털키",
                content: "공유받은 디지털 키가 없습니다. 이용 당일 차량 인도 후 이용하실 수 있습니다.",
                okText: String.confirm,
                onOk() {},
            });
        } else {
            navigate(Common.PAGE_DIGITALKEY_CONTROL);
        }
    }, [resultGetMyShareCarsForDigitalKey]);

    useEffect(() => {
        if (errorGetMyShareCarsForDigitalKey === null) return;

        console.log("errorGetMyShareCarsForDigitalKey", errorGetMyShareCarsForDigitalKey);
    }, [errorGetMyShareCarsForDigitalKey]);

    const {
        loading: loadingGetMyShareCarsForStation,
        error: errorGetMyShareCarsForStation,
        data: resultGetMyShareCarsForStation,
        execute: requestGetMyShareCarsForStation,
    } = useAsyncAxios(requestAxiosGetMyShareCars, false, false, true);

    useEffect(() => {
        if (!resultGetMyShareCarsForStation) return;
        if (resultGetMyShareCarsForStation.carSharers.length === 0) {
            Modal.info({
                centered: true,
                title: "충전소 찾기",
                content: "이용 당일 차량 인도 후 이용하실 수 있습니다.",
                okText: String.confirm,
                onOk() {},
            });
        } else {
            navigate(Common.PAGE_FIND_EV_STATION);
        }
    }, [resultGetMyShareCarsForStation]);

    useEffect(() => {
        if (!errorGetMyShareCarsForStation) return;

        console.log("errorGetMyShareCarsForStation", errorGetMyShareCarsForStation);
    }, [errorGetMyShareCarsForStation]);

    //get boardArticles
    const requestAxiosGetBoardArticles = async (boardIds: string) => {
        const response = await utilAxiosWithAppToken().get(
            Request.BOARD_URL + "/" + Common.BEST_REVIEW_BOARD_ID + "-" + Common.USER_REVIEW_BOARD_ID,
            {
                params: { page: 0, size: 0 },
            }
        );
        return response.data;
    };

    const {
        loading: loadingGetBoardArticles,
        error: errorGetBoardArticles,
        data: resultGetBoardArticles,
        execute: requestGetBoardArticles,
    } = useAsyncAxios(requestAxiosGetBoardArticles);

    useEffect(() => {
        if (!resultGetBoardArticles) return;
        console.log("resultGetBoardArticles", resultGetBoardArticles);

        setBestReviews(resultGetBoardArticles.boardArticles.content);
    }, [resultGetBoardArticles]);

    useEffect(() => {
        if (!errorGetBoardArticles) return;

        console.log("errorGetBoardArticles", errorGetBoardArticles);
    }, [errorGetBoardArticles]);

    //get videoManuals
    const requestAxiosGetRentVideoManuals = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_MANUAL_VIDEOS_URL);
        return response.data;
    };

    const {
        loading: loadingGetRentVideoManuals,
        error: errorGetRentVideoManuals,
        data: resultGetRentVideoManuals,
        execute: requestGetRentVideoManuals,
    } = useAsyncAxios(requestAxiosGetRentVideoManuals);

    useEffect(() => {
        if (!resultGetRentVideoManuals) return;
        console.log("resultGetRentVideoManuals", resultGetRentVideoManuals);

        setRentVideoManuals(Utils.sortRentVideoManuals(resultGetRentVideoManuals.rentVideoManuals));
    }, [resultGetRentVideoManuals]);

    useEffect(() => {
        if (!errorGetRentVideoManuals) return;
        console.log("errorGetRentVideoManuals", errorGetRentVideoManuals);
    }, [errorGetRentVideoManuals]);

    //get periodLimitis
    const requestAxiosGetRentPeriodLimits = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_PERIOD_LIMITS_URL, {
            params: {
                startDate: moment().startOf("month").format("YYYY-MM-DD"),
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetRentPeriodLimits,
        error: errorGetRentPeriodLimits,
        data: resultGetRentPeriodLimits,
        execute: requestGetRentPeriodLimits,
    } = useAsyncAxios(requestAxiosGetRentPeriodLimits);

    useEffect(() => {
        if (!resultGetRentPeriodLimits) return;
        console.log("resultGetRentPeriodLimits", resultGetRentPeriodLimits);

        setRentPeriodLimits(resultGetRentPeriodLimits.rentPeriodLimits);
    }, [resultGetRentPeriodLimits]);

    useEffect(() => {
        if (!errorGetRentPeriodLimits) return;

        console.log("errorGetRentPeriodLimits", errorGetRentPeriodLimits);
    }, [errorGetRentPeriodLimits]);

    //get peakSeasons
    const requestAxiosGetRentPeakSeasons = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_PEAK_SEASONS_URL, {
            params: {
                startDate: moment().startOf("month").format("YYYY-MM-DD"),
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetRentPeakSeasons,
        error: errorGetRentPeakSeasons,
        data: resultGetRentPeakSeasons,
        execute: requestGetRentPeakSeasons,
    } = useAsyncAxios(requestAxiosGetRentPeakSeasons);

    useEffect(() => {
        if (!resultGetRentPeakSeasons) return;
        console.log("resultGetRentPeakSeasons", resultGetRentPeakSeasons);

        setRentPeakSeasons(resultGetRentPeakSeasons.rentPeakSeasons);
    }, [resultGetRentPeakSeasons]);

    useEffect(() => {
        if (!errorGetRentPeakSeasons) return;

        console.log("errorGetRentPeakSeasons", errorGetRentPeakSeasons);
    }, [errorGetRentPeakSeasons]);

    const getAllStartDateBetweenDate = (startDate: string, endDate: string) => {
        const start = moment(startDate).clone();
        const dates = [];

        while (start.isBefore(moment(endDate))) {
            dates.push(start.format(Common.FORMAT_DATE));
            start.add(1, "days");
        }

        return dates;
    };

    const isOwnedB2b = (b2bId?: number) => {
        return (
            ["ROLE_ADMIN", "ROLE_MANAGER"].includes(userDetails?.user?.authority) ||
            (b2bId && userDetails?.user?.b2bs?.some((b2b: TypeDTO.B2bDto) => b2b.b2bId === b2bId)) ||
            !b2bId
        );
    };

    const goToDigitalKeyController = () => {
        if (!userDetails?.token) {
            Modal.info({
                centered: true,
                title: "디지털키",
                content: "로그인 후 사용할 수 있습니다.",
                okText: String.confirm,
                onOk() {},
            });
        } else {
            requestGetMyShareCarsForDigitalKey();
        }
    };

    const goToFindEVStation = () => {
        if (!userDetails?.token) {
            Modal.info({
                centered: true,
                title: "충전소 찾기",
                content: "로그인 후 사용할 수 있습니다.",
                okText: String.confirm,
                onOk() {},
            });
        } else {
            requestGetMyShareCarsForStation();
        }
    };

    const sendMapUrl = useCallback(
        (type: "naver" | "tmap" | "kakao") => {
            let uri = "";

            if (type === "naver") {
                uri = `nmap://route/car?dlat=${travelSpot?.latitude}&dlng=${travelSpot?.longitude}&dname=${travelSpot?.address}`;
            } else if (type === "tmap") {
                uri = `tmap://route?goalname=${travelSpot?.address}&goalx=${travelSpot?.longitude}&goaly=${travelSpot?.latitude}`;
            } else if (type === "kakao") {
                uri = `kakaomap://route?ep=${travelSpot?.latitude},${travelSpot?.longitude}&by=CAR`;
            }

            window.location.href = uri;
        },
        [travelSpot]
    );

    const requestAxiosGetTravelSpots = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_TRAVEL_SPOTS_URL);
        return response.data;
    };

    const {
        loading: loadingGetTravelSpots,
        error: errorGetTravelSpots,
        data: resultGetTravelSpots,
        execute: requestGetTravelSpots,
    } = useAsyncAxios(requestAxiosGetTravelSpots);

    useEffect(() => {
        if (!resultGetTravelSpots) return;
        console.log("resultGetTravelSpots", resultGetTravelSpots);

        const originSpots: Array<TypeDTO.RentTravelSpotDto> = resultGetTravelSpots.travelSpots;
        const modifiedSpots: Array<TypeDTO.RentPlaceDto> = [];
        let modifiedSpotsItem: TypeDTO.RentPlaceDto | null = null;

        originSpots.forEach((originSpot) => {
            modifiedSpotsItem = {
                rentRegionId: originSpot.travelSpotId,
                rentRegionDescription: originSpot.travelSpotName,
                latitude: originSpot.latitude,
                longitude: originSpot.longitude,
                address: originSpot.travelSpotAddress,
                marker:
                    originSpot.travelSpotMarkers?.map((markerArray: any) => ({
                        facilityType: markerArray.facilityType,
                        facilityLatitude: markerArray.latitude,
                        facilityLongitude: markerArray.longitude,
                    })) || [],
                region:
                    originSpot.region?.map((regionArray: any) => ({
                        lat: regionArray.lat,
                        lng: regionArray.lng,
                    })) || [],
            };
            modifiedSpots.push(modifiedSpotsItem);
        });
        setModifiedPlaces(modifiedSpots);
        setOriginPlaces(originSpots);
    }, [resultGetTravelSpots]);
    const onClick = (carId: number, b2bId?: number) => {
        if (!isOwnedB2b(b2bId)) {
            Modal.warning({ centered: true, title: String.msg_onlyB2bMember, okText: String.confirm, onOk() {} });
            return;
        }

        if (b2bId) {
            !b2bSearch?.period || !b2bSearch?.period[1]
                ? navigate(Common.PAGE_RENT_DETAIL + "/" + carId + "/" + b2bSearch?.regionId)
                : navigate(
                      Common.PAGE_RENT_DETAIL + "/" + carId + "/" + b2bSearch?.regionId + "/" + b2bSearch?.period[0] + "/" + b2bSearch?.period[1]
                  );
        } else {
            !search?.period || !search?.period[1]
                ? navigate(Common.PAGE_RENT_DETAIL + "/" + carId + "/" + search?.regionId)
                : navigate(Common.PAGE_RENT_DETAIL + "/" + carId + "/" + search?.regionId + "/" + search?.period[0] + "/" + search?.period[1]);
        }
    };

    const onChange = (value: TypeUtils.SearchType) => {
        setSearch({ regionId: value.regionId, period: value.period });
    };

    const onB2bChange = (value: TypeUtils.SearchType) => {
        setB2bSearch({ regionId: value.regionId, period: value.period });
    };

    return (
        <>
            {openReservationPopup && (
                <ReservationPopup
                    open={true}
                    onChangedOpen={(opened) => {
                        setOpenReservationPopup(opened);
                    }}
                />
            )}

            <MobileView className="mobile">
                <div style={{ minHeight: "calc(100vh - 70px)", display: "flex", flexDirection: "column" }}>
                    <ImageSlider style={{ width: "auto", textAlign: "center" }} images={mobileBanners} />

                    {bestReviews?.length > 0 && (
                        <>
                            <div className="main-subtitle">
                                <h4>이용 후기</h4>
                                <Link to={Common.PAGE_RENT_BEST_REVIEW}>
                                    전체보기 <img src={IconRight} />
                                </Link>
                            </div>
                            <div className="simple-slider" style={{ marginTop: 0 }}>
                                {bestReviews.map((review) => (
                                    <ReviewSimpleCard key={review.boardArticleId} boardArticle={review} />
                                ))}
                            </div>
                            <Divider className="main-divider" />
                        </>
                    )}

                    <div className="space-page" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <div className="main-subtitle" style={{ margin: "0 0 16px" }}>
                            <h4>RUTA40 렌트</h4>
                        </div>
                        <Search
                            disabledDates={disableStartDates}
                            rentPeriodLimits={rentPeriodLimits}
                            rentPeakSeasons={rentPeakSeasons}
                            onChange={onChange}
                        />
                        {loading ? (
                            <CustomLoading />
                        ) : rents?.length ? (
                            <>
                                <div className="mt-3 mb-3">
                                    {rents?.map(({ rentCars }, index) =>
                                        rentCars.map((rentCar) => (
                                            <div key={rentCar.rentCarId} onClick={() => onClick(rentCar.rentCarId)}>
                                                <Title
                                                    searchType={true}
                                                    info={{
                                                        regionName: {
                                                            content: rentCar?.rentRegion?.rentRegionName,
                                                        },
                                                        title: {
                                                            content: rentCar?.title,
                                                        },
                                                        priceDiscounted: {
                                                            content: rentCar?.discountPrice,
                                                        },
                                                        price: {
                                                            content: rentCar?.price,
                                                        },
                                                        tags: rentCar?.rentRestrictions,
                                                    }}
                                                />
                                                {index + 1 < rentCars.length && <Divider />}
                                            </div>
                                        ))
                                    )}
                                </div>
                            </>
                        ) : (
                            <NoData msg="해당 조건의 차량이 없습니다. 다른 조건으로 검색해 주세요." />
                        )}
                        <Divider style={{ borderTopColor: "#ccc" }} />
                        <div className="main-subtitle" style={{ margin: "0 0 16px" }}>
                            <h4>단체 전용 렌트</h4>
                        </div>
                        <Search
                            isB2b
                            disabledDates={disableB2bStartDates}
                            rentPeriodLimits={rentPeriodLimits}
                            rentPeakSeasons={rentPeakSeasons}
                            onChange={onB2bChange}
                        />
                        {b2bLoading ? (
                            <CustomLoading />
                        ) : rents?.length ? (
                            <>
                                <div className="mt-3 mb-3">
                                    {rents?.map(({ rentCars }, index) =>
                                        rentCars.map((rentCar) => (
                                            <div key={rentCar.rentCarId} onClick={() => onClick(rentCar.rentCarId)}>
                                                <Title
                                                    searchType={true}
                                                    info={{
                                                        regionName: {
                                                            content: rentCar?.rentRegion?.rentRegionName,
                                                        },
                                                        title: {
                                                            content: rentCar?.title,
                                                        },
                                                        priceDiscounted: {
                                                            content: rentCar?.discountPrice,
                                                        },
                                                        price: {
                                                            content: rentCar?.price,
                                                        },
                                                        tags: rentCar?.rentRestrictions,
                                                    }}
                                                />
                                                {index + 1 < rentCars.length && <Divider />}
                                            </div>
                                        ))
                                    )}
                                </div>
                            </>
                        ) : (
                            <NoData msg="해당 조건의 차량이 없습니다. 다른 조건으로 검색해 주세요." />
                        )}
                    </div>

                    <Divider className="main-divider" style={{ marginTop: 6 }} />

                    <div className="main-subtitle">
                        <h4>추천 여행지</h4>
                        <Link to={Common.PAGE_TRAVEL_SPOT}>
                            전체보기 <img src={IconRight} />
                        </Link>
                    </div>
                    <div className="simple-slider" style={{ marginTop: 0 }}>
                        {modifiedPlaces.map((place, index) => (
                            <div key={index} className="travel-spot-item">
                                <KakaoMap
                                    mapCenter={{
                                        lat: Number(place?.latitude ?? 0),
                                        lng: Number(place?.longitude ?? 0),
                                    }}
                                    mapStyle={{ aspectRatio: "4/3" }}
                                    rentalLocation={{ list: place }}
                                    guideRegion={place.region ? place.region : undefined}
                                    guideMarker={place.marker ? place.marker : undefined}
                                />
                                <div className="travel-spot-summary">
                                    <div className="travel-spot-name">
                                        <div>{place?.rentRegionDescription}</div>
                                        <Button
                                            type="text"
                                            className="h-100 p-0"
                                            style={{ fontSize: 12, fontWeight: "bold", color: "#005FDB", float: "right" }}
                                            onClick={() => setTravelSpot(place)}
                                        >
                                            {String.navigation}
                                        </Button>
                                    </div>
                                    <div className="travel-spot-address">{place.address}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <CustomSheet
                        isOpen={travelSpot !== null}
                        content={
                            <div style={{ padding: "0 1.5rem 1.5rem 1.5rem", overflowX: "hidden" }}>
                                <h5 className="mb-3">{String.linkProgram}</h5>
                                <div className="px-1 text-center" style={{ display: "flex", justifyContent: "space-around" }}>
                                    <a className="h-100" onClick={() => sendMapUrl("naver")} target="_self" rel="noreferrer">
                                        <img src={IconNaver} width={60} />
                                        <p className="text-black">{String.naverMap}</p>
                                    </a>
                                    <a className="h-100" onClick={() => sendMapUrl("tmap")} target="_self" rel="noreferrer">
                                        <img src={IconTmap} width={60} style={{ marginBottom: "6px" }} />
                                        <p className="text-black">{String.tMap}</p>
                                    </a>
                                    <a className="h-100" onClick={() => sendMapUrl("kakao")} target="_self" rel="noreferrer">
                                        <img src={IconKakao} width={60} />
                                        <p className="text-black">{String.kakaoMap}</p>
                                    </a>
                                </div>
                            </div>
                        }
                        snapHeight={200}
                        onClose={() => setTravelSpot(null)}
                    />

                    <Divider className="main-divider" />

                    <div className="main-subtitle">
                        <h4>매뉴얼</h4>
                        <Link to={Common.PAGE_RENT_MANUAL}>
                            전체보기 <img src={IconRight} />
                        </Link>
                    </div>
                    <div className="simple-slider" style={{ marginTop: 0, marginBottom: 50 }}>
                        {rentVideoManuals.map((rentVideoManuals, index) => (
                            <div className="rent-video-manual-item" key={index}>
                                <RentVideoManualCard rentVideoManual={rentVideoManuals} />
                            </div>
                        ))}
                    </div>

                    <Button
                        className="p-0 btn-dark"
                        type="primary"
                        style={{ width: "42px", height: "42px", position: "fixed", bottom: "66px", right: "14px", zIndex: 4 }}
                        onClick={() => goToFindEVStation()}
                    >
                        <img src={IconEVCharger} width={20} height={22} style={{ marginBottom: 1 }} />
                    </Button>
                    <Button
                        className="p-0 btn-dark"
                        type="primary"
                        style={{ width: "42px", height: "42px", position: "fixed", bottom: "14px", right: "14px", zIndex: 4 }}
                        onClick={() => goToDigitalKeyController()}
                    >
                        <img src={IconDigitalKey} width={20} height={22} style={{ marginLeft: 3, marginBottom: 1 }} />
                    </Button>
                </div>
            </MobileView>
            <BrowserView className="browser">
                <div style={{ minHeight: "calc(100vh - 70px)", width: "100vw", marginBottom: 50 }}>
                    <div className="banner">
                        <ImageSlider style={{ textAlign: "center", objectFit: "cover" }} images={banners} />
                    </div>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 22, offset: 1 }}
                        lg={{ span: 18, offset: 3 }}
                        xl={{ span: 16, offset: 4 }}
                        xxl={{ span: 14, offset: 5 }}
                        className={`fadeIn p-4`}
                    >
                        <>
                            <div className="main-subtitle" style={{ marginTop: 16 }}>
                                <h5>이용 후기</h5>
                                <Link style={{ fontSize: 14 }} to={Common.PAGE_RENT_BEST_REVIEW}>
                                    전체보기 <img src={IconRight} />
                                </Link>
                            </div>
                            <MainCarousel autoPlay={false} showBullets={false}>
                                {bestReviews?.map((review) => (
                                    <div className="embla__slide review" key={review.boardArticleId}>
                                        <ReviewCard boardArticle={review} />
                                    </div>
                                ))}
                            </MainCarousel>
                        </>
                        <h5 style={{ marginTop: "40px", marginBottom: "20px" }}>RUTA40 렌트</h5>
                        <Search
                            onChange={onChange}
                            disabledDates={disableStartDates}
                            rentPeriodLimits={rentPeriodLimits}
                            rentPeakSeasons={rentPeakSeasons}
                        />
                        {loading ? (
                            <CustomLoading />
                        ) : Object.keys(rents).length ? (
                            <>
                                <Row gutter={10}>
                                    {rents?.map(({ rentCars }) =>
                                        rentCars?.map((rent) => (
                                            <Col span={8} key={rent.rentCarId}>
                                                <GoodsCard rentCar={rent} onClick={onClick} />
                                            </Col>
                                        ))
                                    )}
                                </Row>
                            </>
                        ) : (
                            <NoData msg="해당 조건의 차량이 없습니다. 다른 조건으로 검색해 주세요." />
                        )}

                        <h5 style={{ marginTop: "40px", marginBottom: "20px" }}>단체 전용 렌트</h5>
                        <Search
                            isB2b
                            disabledDates={disableB2bStartDates}
                            rentPeriodLimits={rentPeriodLimits}
                            rentPeakSeasons={rentPeakSeasons}
                            onChange={onB2bChange}
                        />
                        {b2bLoading ? (
                            <CustomLoading />
                        ) : Object.keys(b2bRents).length ? (
                            <>
                                <Row gutter={10} className="mt-3 mx-0">
                                    {b2bRents?.map(({ rentCars }) =>
                                        rentCars.map((rent) => (
                                            <Col span={8} key={rent.rentCarId}>
                                                <GoodsCard rentCar={rent} onClick={onClick} disabledPrice={!isOwnedB2b(rent?.b2b?.b2bId)} />
                                            </Col>
                                        ))
                                    )}
                                </Row>
                            </>
                        ) : (
                            <NoData msg="해당 조건의 차량이 없습니다. 다른 조건으로 검색해 주세요." />
                        )}
                        <div className="main-subtitle">
                            <h5>추천 여행지</h5>
                            <Link style={{ fontSize: 14 }} to={Common.PAGE_TRAVEL_SPOT}>
                                전체보기 <img src={IconRight} />
                            </Link>
                        </div>
                        <MainCarousel autoPlay={false} showBullets={false}>
                            {originPlaces.map((place, index) => (
                                <div key={index} className="embla__slide travel-spot">
                                    <TravelSpotCard place={place} isHome={true} />
                                </div>
                            ))}
                        </MainCarousel>
                        {bestReviews?.length > 0 && (
                            <>
                                <div className="main-subtitle">
                                    <h5>매뉴얼</h5>
                                    <Link style={{ fontSize: 14 }} to={Common.PAGE_RENT_MANUAL}>
                                        전체보기 <img src={IconRight} />
                                    </Link>
                                </div>
                                <MainCarousel autoPlay={false} showBullets={false}>
                                    {rentVideoManuals.map((rentVideoManuals, index) => (
                                        <div className="embla__slide rent-video-manual" key={index}>
                                            <RentVideoManualCard rentVideoManual={rentVideoManuals} />
                                        </div>
                                    ))}
                                </MainCarousel>
                            </>
                        )}
                    </Col>
                </div>
            </BrowserView>
        </>
    );
}

export default Home;
